import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Button, Card, Alert, Table } from 'react-bootstrap'
import { fetchAdminList } from './api/api'
import { humanizeDate } from '../Utils/Dates/Dates'
import { AdminDetail } from './Components/AdminDetail'

export const Superadmin = () => {
    const [password, setPassword] = useState('')
    const [authenticated, setAuthenticated] = useState(false)
    const [error, setError] = useState(false)
    const [admins, setAdmins] = useState([])
    const [selectedAdmin, setSelectedAdmin] = useState(null)

    const handleSubmit = (e) => {
        e.preventDefault()
        if (password === process.env.REACT_APP_SUPERPUBLICADMIN_PASSWORD) {
            setAuthenticated(true)
            setError(false)
        } else {
            setError(true)
        }
    }

    useEffect(() => {
        if (authenticated) {
            fetchAdminList().then((res) => {
                setAdmins(res)
            })
        }
    }, [authenticated])

    if (!authenticated) {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                <Row className="justify-content-center w-75">
                    <Col md={6}>
                        <Card className="shadow p-4">
                            <Card.Body>
                                <h2 className="text-center mb-4">Superadmin Access</h2>
                                {error && <Alert variant="danger">Incorrect password. Please try again.</Alert>}
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Enter password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    <Button variant="primary" type="submit" className="w-100">
                                        Access
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <>
            {!selectedAdmin &&
                <div className="mt-4 w-full m-auto w-75">
                    <h1>Superadmin dashboard</h1>

                    <div className='mt-4'>
                        <h2>Administradores</h2>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th className='text-sm text-primary text-center'>Nombre</th>
                                <th className='text-sm text-primary text-center'>Usuario Plataforma</th>
                                <th className='text-sm text-primary text-center'>Plataforma</th>
                                <th className='text-sm text-primary text-center'>URL del Gestor</th>
                                <th className='text-sm text-primary text-center'>Última Actividad</th>
                                <th className='text-sm text-primary text-center'>Fecha Creación</th>
                                <th className='text-sm text-primary text-center'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {admins?.map((row) => (
                                <tr key={row.id}>
                                    <td className='text-sm text-primary text-center'>{row?.name}</td>
                                    <td className='text-sm text-primary text-center'>{row?.nickname}</td>
                                    <td className='text-sm text-primary text-center'>{row?.platform}</td>
                                    <td className='text-sm text-primary text-center'>{row?.gestorUrl}</td>
                                    <td className='text-sm text-primary text-center'>{humanizeDate(row?.lastActivity)}</td>
                                    <td className='text-sm text-secondary text-center'>{humanizeDate(row?.createdAt)}</td>
                                    <td className='text-sm text-primary text-center'>
                                        <Button variant="primary" onClick={() => setSelectedAdmin(row.id)}>
                                            Ver Detalles
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            }
            {selectedAdmin && <AdminDetail adminId={selectedAdmin} setSelectedAdmin={setSelectedAdmin} />}
        </>
    )
}
